import { GET_SUMMARY_DATA } from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface getSummaryDataState extends BaseAsyncReducerState {
    success: boolean,
    message: string
}
  
const initialState: getSummaryDataState = {
    success: false,
    message: "",
    loading: false,
    error: false
}

function getSummaryDataReducer(state = initialState, action: AppAction) {
  return defaultAsyncReducer(state, action as AppAction, GET_SUMMARY_DATA)
}

export default getSummaryDataReducer;